export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const PLAN_INFO = {
    'Creator': { gens: 3, rewrites: 10 },
    'Discoverer': { gens: 8, rewrites: 30 },
    'Architect': { gens: 20, rewrites: 60 },
    'Endovelicus': { gens: Infinity, rewrites: Infinity }
};

export const TONES = [
    { value: "Neutral / Authentic", label: "Neutral / Authentic (Relatable & Trusted)" },
    { value: "Provocative & Engaging", label: "Provocative & Engaging (Bold & Edgy)" },
    { value: "Professional & Informative", label: "Professional & Informative (Expert & Precise)" },
    { value: "Dramatic Storytelling", label: "Dramatic Storytelling (Immersive & Intense)" },
    { value: "Educational & Factual", label: "Educational & Factual (Clear & Insightful)" },
    { value: "Comical / Fun", label: "Comical / Fun (Lighthearted & Witty)" },
    { value: "The Dissident / Truth-Seeker", label: "The Dissident / Truth-Seeker (Counter-Narrative)" },
    { value: "The Deep-Dive Investigator", label: "The Deep-Dive Investigator (Detailed & Investigative)" },
    { value: "The Hype-Beast", label: "The Hype-Beast (High-Energy Viral Hook)" },
    { value: "The Breaking News Anchor", label: "The Breaking News Anchor (Urgent & Direct)" },
    { value: "The Color Commentator", label: "The Insight Analyst (Vivid & Descriptive)" },
];

export const ATTRIBUTIONS = [
    { value: 'none', label: 'Do not mention me' },
    { value: 'name', label: 'Mention my name' },
    { value: 'channel', label: 'Mention my channel' },
    { value: 'both', label: 'Mention my name + channel' }
];

export const SHORT_STYLES = [
    "Provocative",
    "Myth vs Fact",
    "PAS (Problem-Agitate-Solve)",
    "Tutorial / How-to",
    "Reaction / Commentary"
];
